import React, { FC, useCallback, useEffect, useMemo } from 'react'
import OnboardingStepTemplate from '../OnboardingStepTemplate'
import { Box, Button, Text } from '@chakra-ui/react'
import { styled } from 'styled-components'
import { useReduxSelector } from '../../../../redux/baseStore'
import { selectSessionSessions } from '../../../../redux/sessionSlice'
import { useDeleteOpenTabsMutation } from '../../../../webapp/redux/extension'
import {
  getOldestSession,
  ONBOARDING_ORGANIZED_SESSION_ID_KEY,
} from '../../../../utils/sessionUtils'

const Container = styled(Box)`
  .large-text,
  .large-text * {
    font-size: 28px;
    font-weight: 500;
    line-height: 40px;
    color: #000;
    letter-spacing: -1px;

    @media (max-width: 1200px) {
      /* Screens narrower than 1200px */
      font-size: 24px;
      line-height: 36px;
    }
  }
`

interface Props {
  onNext: () => void
}
const OnboardingSessionsCleanUpV3Dialog: FC<Props> = (props) => {
  const { onNext } = props
  const sessions = useReduxSelector(selectSessionSessions)
  const [deleteOpenTabs] = useDeleteOpenTabsMutation()

  const oldestSession = useMemo(() => {
    return getOldestSession(sessions)
  }, [sessions])

  const closeSessionTabs = useCallback(() => {
    const ids =
      oldestSession?.pages
        .filter((page) => page?.is_open)
        .map((page) => page?.id?.toString())
        .filter((id): id is string => id !== undefined) ?? []
    if (ids.length > 0) {
      deleteOpenTabs({ ids })
    }
  }, [oldestSession, deleteOpenTabs])

  const goNext = useCallback(() => {
    localStorage.removeItem(ONBOARDING_ORGANIZED_SESSION_ID_KEY)
    onNext()
  }, [onNext])

  useEffect(() => {
    if (oldestSession) {
      setTimeout(() => {
        const element = document.querySelector(`[data-session-id="${oldestSession?.id}"]`)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }, 500)
    }
  }, [oldestSession])

  return (
    <OnboardingStepTemplate
      phaseNum={4}
      numPhases={6}
      bodyContent={
        <Container>
          <Text className="large-text" mb="4px">
            We noticed you haven&apos;t looked at your &quot;{oldestSession?.name}&quot; tabs in a
            while.
          </Text>
          <Text mt="4" className="large-text" mb="4px">
            Why don&apos;t we close those for you, since they&apos;re safe and sound in your
            Session?
          </Text>
        </Container>
      }
      buttonText={`Yes close them`}
      onButtonClick={() => {
        closeSessionTabs()
        goNext()
      }}
      delayButtonActivation={false}
      secondaryButton={
        <>
          <Button
            marginRight="8px"
            size="lg"
            variant="ghost"
            borderRadius="100px"
            paddingRight="24px"
            paddingLeft="24px"
            color={'black'}
            border="1px solid #FFF"
            fontWeight={500}
            _hover={{
              backgroundColor: '#EBEBEB',
            }}
            onClick={goNext}
            isLoading={false}
            isDisabled={false}
          >
            Keep them open
          </Button>
        </>
      }
    />
  )
}

export default OnboardingSessionsCleanUpV3Dialog
